document.addEventListener('click', async function(event) {
  const button = event.target.closest('.js-grid-add-to-cart');

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = button.dataset.variantId;

  if (!variantId || button.disabled) return;

  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'Adding...';

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || 'Unable to add product to cart');
    }

    document.dispatchEvent(new CustomEvent('cart:build'));

    button.textContent = 'Added to bag';

    setTimeout(function() {
      button.textContent = originalText;
      button.disabled = false;
    }, 1500);

  } catch (error) {
    console.error('Add to cart error:', error);

    button.textContent = 'Please try again';
    button.disabled = false;
  }
});